<template>
  <router-link
    v-if="props.funds.length == 1"
    :to="{
      name: 'membershipFundHistory',
      params: { fundId: props.funds[0].id },
    }"
    style="text-decoration: none"
  >
    <fund-card :color="props.color" :fund="props.funds[0]"></fund-card>
  </router-link>
  <v-slide-group v-else class="fund-group">
    <v-slide-group-item v-for="f in props.funds" :key="f.id" class="fund-card">
      <router-link
        :to="{ name: 'membershipFundHistory', params: { fundId: f.id } }"
        style="text-decoration: none"
      >
        <fund-card :color="props.color" :fund="f"></fund-card>
      </router-link>
    </v-slide-group-item>
  </v-slide-group>
</template>

<script setup>
import FundCard from "@/components/membership/FundCard.vue";
import { defineProps } from "vue";

const props = defineProps(["color", "funds"]);
</script>

<style scoped>
.fund-group > .fund-card {
  max-width: 300px;
}
</style>
